import React from "react";
import EditableDataDisplay from "./EditableDataDisplay";

const DocumentExpandedView = ({
  doc,
  isDarkMode,
  themeClasses,
  documentViewModes,
  resultViewMode,
  editingDocuments,
  savingDocuments,
  handleDocumentViewModeChange,
  handleEditDocument,
  handleSaveDocument,
  handleCancelEdit,
  copyToClipboard,
  downloadAsCSV,
  toggleResultViewMode,
  MediaViewer,
  hasMediaToggle = true,
  presignedUrls,
  loadingUrls,
  fetchPresignedUrls,
}) => {
  // Check if document has media
  const documentHasMedia = doc.has_media || doc.media || doc.file_type;

  return (
    <div
      className={`${hasMediaToggle ? "p-4" : "px-4 pb-4"} rounded border${
        isDarkMode
          ? hasMediaToggle
            ? "border-slate-950 bg-gray-800"
            : "border-slate-950"
          : hasMediaToggle
          ? "border-slate-280 bg-gray-50"
          : "border-slate-280"
      }`}
    >
      {/* Data/Media Toggle - Only show if document has media */}
      {hasMediaToggle && documentHasMedia && (
        <div className="flex items-center justify-between mb-4">
          <span
            className={`text-sm font-medium ${
              isDarkMode ? "text-gray-300" : "text-gray-700"
            }`}
          >
            Content View:
          </span>
          <div
            className={`flex items-center rounded-lg p-1 ${
              isDarkMode ? "bg-gray-700" : "bg-gray-100"
            }`}
          >
            <button
              onClick={() => handleDocumentViewModeChange(doc.id, "data")}
              className={`px-3 py-1.5 rounded-md text-xs font-medium transition-all duration-200 ${
                (documentViewModes[doc.id] || "data") === "data"
                  ? isDarkMode
                    ? "bg-blue-600 text-white shadow-sm"
                    : "bg-blue-500 text-white shadow-sm"
                  : isDarkMode
                  ? "text-gray-300 hover:text-white hover:bg-gray-600"
                  : "text-gray-600 hover:text-gray-900 hover:bg-gray-200"
              }`}
            >
              <svg
                className="w-3 h-3 inline mr-1"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                />
              </svg>
              Data
            </button>
            <button
              onClick={() => handleDocumentViewModeChange(doc.id, "image")}
              className={`px-3 py-1.5 rounded-md text-xs font-medium transition-all duration-200 ${
                (documentViewModes[doc.id] || "data") === "image"
                  ? isDarkMode
                    ? "bg-blue-600 text-white shadow-sm"
                    : "bg-blue-500 text-white shadow-sm"
                  : isDarkMode
                  ? "text-gray-300 hover:text-white hover:bg-gray-600"
                  : "text-gray-600 hover:text-gray-900 hover:bg-gray-200"
              }`}
            >
              <svg
                className="w-3 h-3 inline mr-1"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                />
              </svg>
              Media
            </button>
          </div>
        </div>
      )}

      {!hasMediaToggle && documentHasMedia && (
        <div className="flex justify-between items-center mt-4 mb-3">
          <span
            className={`text-sm font-medium ${
              isDarkMode ? "text-gray-300" : "text-gray-700"
            }`}
          >
            View:
          </span>
          <div
            className={`flex items-center rounded-lg p-1 ${
              isDarkMode ? "bg-gray-700" : "bg-gray-100"
            }`}
          >
            <button
              onClick={() => handleDocumentViewModeChange(doc.id, "data")}
              className={`px-3 py-1.5 rounded-md text-xs font-medium transition-all duration-200 ${
                (documentViewModes[doc.id] || "data") === "data"
                  ? isDarkMode
                    ? "bg-blue-600 text-white shadow-sm"
                    : "bg-blue-500 text-white shadow-sm"
                  : isDarkMode
                  ? "text-gray-300 hover:text-white hover:bg-gray-600"
                  : "text-gray-600 hover:text-gray-900 hover:bg-gray-200"
              }`}
            >
              <svg
                className="w-3 h-3 inline mr-1"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                />
              </svg>
              Data
            </button>
            <button
              onClick={() => handleDocumentViewModeChange(doc.id, "image")}
              className={`px-3 py-1.5 rounded-md text-xs font-medium transition-all duration-200 ${
                (documentViewModes[doc.id] || "data") === "image"
                  ? isDarkMode
                    ? "bg-blue-600 text-white shadow-sm"
                    : "bg-blue-500 text-white shadow-sm"
                  : isDarkMode
                  ? "text-gray-300 hover:text-white hover:bg-gray-600"
                  : "text-gray-600 hover:text-gray-900 hover:bg-gray-200"
              }`}
            >
              <svg
                className="w-3 h-3 inline mr-1"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2 2v12a2 2 0 002 2z"
                />
              </svg>
              Media
            </button>
          </div>
        </div>
      )}

      {/* Media Preview - Only show if document has media and image view is selected */}
      {documentHasMedia &&
        (documentViewModes[doc.id] || "data") === "image" && (
          <MediaViewer
            doc={doc}
            isDarkMode={isDarkMode}
            presignedUrls={presignedUrls}
            loadingUrls={loadingUrls}
            fetchPresignedUrls={fetchPresignedUrls}
          />
        )}

      {/* GPT Results Section - only show in data view */}
      {(documentViewModes[doc.id] || "data") === "data" && (
        <>
          <div className="flex justify-end mb-2 space-x-2 mt-4">
            <button
              onClick={() => copyToClipboard(doc.gpt_result)}
              className={`px-2 py-1 text-xs rounded flex items-center ${
                isDarkMode
                  ? "bg-gray-600 hover:bg-gray-500 text-gray-200"
                  : "bg-gray-200 hover:bg-gray-300 text-gray-700"
              }`}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-3.5 h-3.5 mr-1"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                <path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1"></path>
              </svg>
              Copy
            </button>

            <button
              onClick={() => handleEditDocument(doc.id)}
              className={`px-2 py-1 text-xs rounded flex items-center ${
                isDarkMode
                  ? "bg-blue-600 hover:bg-blue-500 text-blue-200"
                  : "bg-blue-200 hover:bg-blue-300 text-blue-700"
              }`}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-3.5 h-3.5 mr-1"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"></path>
                <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"></path>
              </svg>
              Edit
            </button>

            <button
              onClick={() => downloadAsCSV(doc.gpt_result)}
              className={`px-2 py-1 text-xs rounded flex items-center ${
                isDarkMode
                  ? "bg-green-600/30 hover:bg-green-500/40 text-green-300"
                  : "bg-green-100 hover:bg-green-200 text-green-700"
              }`}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-3.5 h-3.5 mr-1"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"></path>
                <polyline points="7 10 12 15 17 10"></polyline>
                <line x1="12" y1="15" x2="12" y2="3"></line>
              </svg>
              CSV
            </button>

            <button
              onClick={() => toggleResultViewMode(doc.id)}
              className={`px-2 py-1 text-xs rounded ${
                isDarkMode
                  ? "bg-gray-600 hover:bg-gray-500 text-gray-200"
                  : "bg-gray-200 hover:bg-gray-300 text-gray-700"
              }`}
            >
              Switch to{" "}
              {resultViewMode[doc.id] === "json" ? "Formatted" : "JSON"} View
            </button>
          </div>

          {/* GPT Results Section */}
          <div
            className={`rounded-lg border ${
              isDarkMode
                ? "bg-gray-900/50 border-slate-950"
                : "bg-white border-slate-280"
            } p-4`}
          >
            <div className="flex items-center mb-3">
              <svg
                className={`w-5 h-5 mr-2 ${
                  isDarkMode ? "text-blue-400" : "text-blue-600"
                }`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                />
              </svg>
              <span
                className={`text-sm font-medium ${
                  isDarkMode ? "text-gray-300" : "text-gray-700"
                }`}
              >
                Extracted Data
              </span>
            </div>

            {/* Conditional Rendering */}
            {resultViewMode[doc.id] === "json" ? (
              <pre
                className={`whitespace-pre-wrap text-xs p-3 rounded ${
                  isDarkMode
                    ? "bg-black/30 text-gray-300"
                    : "bg-gray-100 text-gray-800"
                } overflow-x-auto`}
              >
                {(() => {
                  try {
                    let dataToDisplay = doc.gpt_result;
                    // Clean if it's still a string with markdown fences
                    if (typeof dataToDisplay === "string") {
                      let cleanedData = dataToDisplay.trim();
                      if (cleanedData.startsWith("```")) {
                        const match = cleanedData.match(
                          /^```(?:json)?\s*([\s\S]*?)\s*```$/
                        );
                        if (match) cleanedData = match[1];
                      }
                      dataToDisplay = JSON.parse(cleanedData);
                    }
                    return JSON.stringify(dataToDisplay, null, 2);
                  } catch (e) {
                    // If parsing fails, show the original string
                    return doc.gpt_result;
                  }
                })()}
              </pre>
            ) : (
              <EditableDataDisplay
                data={doc.gpt_result}
                themeClasses={themeClasses}
                isDarkMode={isDarkMode}
                isEditing={editingDocuments[doc.id] || false}
                isSaving={savingDocuments[doc.id] || false}
                onEdit={() => handleEditDocument(doc.id)}
                onSave={(updatedData) =>
                  handleSaveDocument(doc.id, updatedData)
                }
                onCancel={() => handleCancelEdit(doc.id)}
              />
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default DocumentExpandedView;
